export default __webpack_public_path__ + "static/media/addComment.6831c972.svg";